import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "./api";

// Client-side gate only — the real protection is the JWT check on every
// /admin API route, so a forged local token still gets nothing back.
const RequireAdmin = ({ children }) => {
  return getToken() ? children : <Navigate to="/admin/login" replace />;
};

export default RequireAdmin;
